import { type FunctionComponent } from 'react';
import { type SubCategory } from '../../../../../types/search.types';
import { CategoryBrowseList } from '../../../category-browse-list/category-browse-list.component';
import { CategoryImageTile, CategoryTextTile } from '../../../category-tile/category-tile.component';

export type CategoriesSectionProps = {
	isFeatured: boolean;
	categories: SubCategory[];
	categoryName?: string; // Optional for non-featured categories
};

export const CategoriesSection: FunctionComponent<CategoriesSectionProps> = ({ categories, categoryName, isFeatured }) => {
	if (categories.length === 0) return null;

	const TileComponent = isFeatured ? CategoryImageTile : CategoryTextTile;
	const containerClass = isFeatured ? 'ph2-ns mb3' : 'w-25-ns ph2 pv3 pv0-ns mb3-ns mb0-l';
	const title = isFeatured ? undefined : `Shop More ${categoryName}`;
	const titleClass = isFeatured ? undefined : 'ba-l b--theme-grey-light ph2 pv3';

	return (
		<div className={isFeatured ? '' : 'db dn-l'}>
			<CategoryBrowseList
				className="flex-row-ns flex-wrap items-center justify-start ph0 w-auto w-100-ns"
				title={title}
				titleClass={titleClass}
				items={categories}
				itemTransform={(categoryProps, index, info) => (
					<TileComponent
						{...categoryProps}
						className={`${containerClass} ${!isFeatured && !info.isLast ? 'bb bn-ns' : ''}`}
						key={categoryProps.id}
						showArrow={true}
						showBorder={true}
						tileClass={isFeatured ? (!info.isLast ? 'bb' : '') : 'pa3-ns tc-ns tc1-title tc3-title-ns tc1-title-l h3-ns'}
						aspectRatio="1x1"
					/>
				)}
			/>
		</div>
	);
};
